import { SocialAuthService, SocialUser } from '@abacritt/angularx-social-login';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { AppCommon } from '../api-providers/app-common';
import { LoginModel } from '../api-providers/models/login.model';
import { LoginViewModel } from '../api-providers/view-models/login.view.model';
import { AppComponent } from '../app.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers:[LoginViewModel, ]
})
export class LoginComponent implements OnInit {

  loginModel = new BehaviorSubject<LoginModel>(new LoginModel());
  googleUser: SocialUser;
  loggedIn: boolean;

  constructor(
    private vm: LoginViewModel,
    private router: Router,
    private authService: SocialAuthService,
  ) {
    
  }

  ngOnInit(): void {

 

    if(AppCommon.isLoggedIn()){
      this.loginSuccess()
    } else{
      this.googleLoginClicked();
    }

  
  }

  googleLoginClicked(){
    this.authService.authState.subscribe((user) => {
      this.googleUser = user;
      AppCommon.setGoogleUserObject(this.googleUser);
      if(this.googleUser){
          this.loginWithGoogle();
      };
      this.loggedIn = (user != null);
  });
  }

  loginWithGoogle(): void {
    this.vm.parentLoginComponent = this;
    this.vm.subscribeLogin(this.loginModel);
    this.vm.authenticate(this.googleUser.idToken);
  }

  loginSuccess(){
    AppComponent.staticCall.isLoggedIn = true;
    this.router.navigate(["/"]);
  }

}
